import { createSlice } from '@reduxjs/toolkit';
import { CreativeItem } from 'cityads-v3/types/creative';
import { makeRequest } from 'cityads-v3/utils/apiUtils';

export const initialState = {

}

export const slice = createSlice({
  name: 'creative',
  initialState,
  reducers: {
    createCreativeItem: () => { },
    createCreativeItemSuccess: () => { },
    createCreativeItemFail: () => { },
    saveCreativeItem: () => { },
    saveCreativeItemSuccess: () => { },
    saveCreativeItemFail: () => { },
  }
})

const {
  createCreativeItem,
  createCreativeItemSuccess,
  createCreativeItemFail,
  saveCreativeItem,
  saveCreativeItemSuccess,
  saveCreativeItemFail,
} = slice.actions

/**
 * Создание креатива
 */
export function createCreative(creative: Partial<CreativeItem>) {
  return makeRequest(`/saduka/creatives`, {
    types: [
      createCreativeItem.type,
      createCreativeItemSuccess.type,
      createCreativeItemFail.type
    ],
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        creative
      })
    }
  })
}

/**
 * Сохранение креатива
 */
export function saveCreative(creative: CreativeItem) {
  return makeRequest(`/saduka/creatives/${creative.id}`, {
    types: [
      saveCreativeItem.type,
      saveCreativeItemSuccess.type,
      saveCreativeItemFail.type
    ],
    options: {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        creative
      })
    }
  });
}

export default slice.reducer;
